(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fbt-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  const visible = 5;
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.hdt-fbt-swatch-more');
    if (!btn) return;
    const wrap = btn.closest('.hdt-fbt-item__swatches-wrap');
    if (!wrap) return;
    const track = wrap.querySelector('[data-fbt-track]');
    if (!track) return;
    track.classList.toggle('is-expanded');
    const expanded = track.classList.contains('is-expanded');
    const total = track.querySelectorAll('.hdt-fbt-swatch').length;
    btn.textContent = expanded ? '-' : '+' + (total - visible);
  });

  document.addEventListener('change', function(e) {
    const radio = e.target;
    if (radio.type !== 'radio' || !radio.dataset.vid) return;
    const bundleItem = radio.closest('hdt-bundle-product[data-fbt-item]');
    if (!bundleItem) return;
    const variantId = radio.dataset.vid;
    const select = bundleItem.querySelector('select.hdt-bundle-select');
    if (select) {
      for (let i = 0; i < select.options.length; i++) {
        if (select.options[i].value == variantId) {
          select.selectedIndex = i;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ftb2-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  const visible = 5;
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.hdt-fbt-swatch-more');
    if (!btn) return;
    const wrap = btn.closest('.hdt-fbt-item__swatches-wrap');
    if (!wrap) return;
    const track = wrap.querySelector('[data-fbt-track]');
    if (!track) return;
    track.classList.toggle('is-expanded');
    const expanded = track.classList.contains('is-expanded');
    const total = track.querySelectorAll('.hdt-fbt-swatch').length;
    btn.textContent = expanded ? '-' : '+' + (total - visible);
  });

  document.addEventListener('change', function(e) {
    const radio = e.target;
    if (radio.type !== 'radio' || !radio.dataset.vid) return;
    const bundleItem = radio.closest('hdt-bundle-product[data-fbt-item]');
    if (!bundleItem) return;
    const variantId = radio.dataset.vid;
    const select = bundleItem.querySelector('select.hdt-bundle-select');
    if (select) {
      for (let i = 0; i < select.options.length; i++) {
        if (select.options[i].value == variantId) {
          select.selectedIndex = i;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
